class ToolboxResourcesAjax {
  constructor() {
    this.$body = $('body')
    this.scopeRole = {
      toolboxWidget: '.toolbox-widget',
      button: '.toolbox-widget__button',
      niveauxField: 'input:checkbox[name="_toolbox_niveaux_scolaire"]',
      thematiquesField: 'input:checkbox[name="_toolbox_thematiques"]',
    }
    this.ajaxMethod = {
      putAction: 'query_toolbox_resources',
    }

    this.data = {
      action: this.ajaxMethod.putAction,
      // eslint-disable-next-line no-undef
      security: ajax_object.ajax_nonce,
      niveaux: [],
      thematiques: [],
    }

    if(this.$body.hasClass('template-resources') && this.$body.find(this.scopeRole.toolboxWidget).length) {
      this.init()
    }
  }

  init() {
    $(this.scopeRole.niveauxField).change(() => {
      let niveauxArray = []
      const $niveauChecked = $(`${this.scopeRole.niveauxField}:checked`)
      if($niveauChecked.length) {
        $(`${this.scopeRole.niveauxField}:checked`).each((_, el) => {
          const $el = $(el)
          niveauxArray.push($el.val())
        })
      }
      this.data.niveaux = niveauxArray
      this.ajaxRequest(this.data)
    })

    $(this.scopeRole.thematiquesField).change(() => {
      let thematiquesArray = []
      const $thematiqueChecked = $(`${this.scopeRole.thematiquesField}:checked`)
      if($thematiqueChecked.length) {
        $(`${this.scopeRole.thematiquesField}:checked`).each((_, el) => {
          const $el = $(el)
          thematiquesArray.push($el.val())
        })
      }
      this.data.thematiques = thematiquesArray
      this.ajaxRequest(this.data)
    })
  }

  ajaxRequest(data) {
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_object.ajax_url,
      method: 'POST',
      data: data,
    }).done((response) => {
      const data = JSON.parse(response)
      this.$body.find(this.scopeRole.button).find('span').html(`(${data.count})`)
    })
  }
}

export default ToolboxResourcesAjax;



// WEBPACK FOOTER //
// ./scripts/components/ToolboxResourcesAjax.js